export function isValidPhoneNumber(value?: string | undefined | null) {
    if (!value) return false;
    const phoneRegexp = /^(\+)?(?:[0-9]?){6,15}[0-9]$/;
    return phoneRegexp.test(value);
}

export function isValidPhoneLength(value?: string | undefined | null) {
    if (!value) return false;
    return value.length <= 16 && value.length >= 5;
}

export function isValidPhoneFormat(phone?: string) {
    if (phone && (!isValidPhoneNumber(phone) || !isValidPhoneLength(phone))) {
        return false;
    }
    return true;
}
